/* eslint-disable */

import axios from 'axios';

axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {

    namespaced: true,
    state: {
        routines: [],
    },
    mutations: {

        setRoutines(state, payload) {
            state.routines = payload
        },
    },

    actions: {
        async getRoutines({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.get(`/get-routines/${payload.siteID}`, payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));
                dispatch('alert/setLoaded', true, {root: true});
                commit('setRoutines', response.data);
            } catch(err) {
                console.log('Error getting Routines:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        }, 
        
        async getRoutine({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});        
                let response = await axios.get(`/get-routine/${payload.routineID}`, payload, { crossdomain: true });
                //console.log('Response:' + JSON.stringify(response));  
                dispatch('alert/setLoaded', true, {root: true});
                return response.data;
            } catch(err) {
                console.log('Error getting a Routine:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async createRoutine({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.post('/create-routine', payload, { crossdomain: true });
                console.log('Response:' + JSON.stringify(response));   
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', 'Routine created successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
            } catch(err) {
                console.log('Error creating a Routine:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },

        async updateRoutine({commit, dispatch}, payload) {
            try {
                dispatch('alert/setLoading', true, {root: true});
                let response = await axios.put(`/update-routine/${payload.RoutineID}`, payload, { crossdomain: true });
                console.log('Response:' + JSON.stringify(response));   
                dispatch('alert/setLoaded', true, {root: true});
                dispatch('alert/setMessage', 'Routine updated successfully!', {root: true});
                dispatch('alert/setDismissSuccessCountDown', 3, {root: true});
            } catch(err) {
                console.log('Error updating a Routine:', err);
                dispatch('alert/setErrored', true, {root: true});
                dispatch('alert/setMessage', err, {root: true});
            }
        },
    }
}